module.exports = __webpack_public_path__ + "static/media/custom.c5eef6f3.png";